<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">隐私保护</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">隐私保护</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p>
                            <img alt="" width="800" height="300" src="https://s.cccgx.com/images/upload/Image/ysbh.jpg">
                        </p>
                        <p><br></p>
                        <p>
                            为了保护广大客户的隐私权，顾客的用户资料只在夜樱情趣内部使用，不会泄露给第三方。对客户的所有订购、咨询严格保密；对于顾客所购买的商品，我们采取保密邮寄；对于您在取货时将看不到任何敏感性标志；对于送货时禁止一切可能暴露客户隐私的包装、标识。
                        </p>
                        <p class="font16">【隐私保护，六重隐身保护】</p>
                        <p>
                            <span>
                                <strong style="color:#E53333;font-size:18px;">第一重，隐蔽包裹</strong>——<span>我们用来邮寄货品的包装外观与普通包裹无异，即便是外面的包装箱破裂，也看不出里面的商品。</span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <strong style="color:#E53333;font-size:18px;">第二重，包裹落款</strong>——<span>落款的货物名称均是"礼品"。</span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <strong style="color:#E53333;font-size:18px;">第三重，送货保密</strong>——<span>您若选择送货上门，不必担心送货员会知道您购买的商品信息。为您送货的送货员均为与我们签约的速递公司的员工，他们只能看见包装好的商品，并不会了解包装内的具体商品。 </span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <strong style="color:#E53333;font-size:18px;">第四重，环境保密</strong>——<span>我们与您电话确认订单时会首先询问"您现在是不是方便接听电话"。我们会确保您与我们通话时没有旁人在场。</span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <strong style="color:#E53333;font-size:18px;">第五重，身份保密</strong>——<span>我们不会问询您除送货信息外的其它用户信息。例如身份证号码、年龄、性别等。</span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <strong style="color:#E53333;font-size:18px;">第六重，收货保密</strong>——<span>收货信息只在我公司内部使用，绝无可能外泄或被用作其它用途。</span>
                            </span>
                        </p>
                        <p>
                            同时，您可以在订单备注栏内标明其他保密要求，我们将优先按您的要求执行，我们尊重您的资料和私隐权，承诺在遵守个人资料(私隐)条例的规定时，将完全遵照国际认可的保障个人资料(私隐)准则，并确保公司职员遵守最严格的安全和保密准则。
                        </p>
                        <p>
                            <img alt="" width="800" height="380" src="https://s.cccgx.com/images/upload/Image/6cbh.jpg">
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/kefu" style="float:left;">上一篇:夜樱情趣商城客服</a>
                        <a href="/help/zhengpinbaozheng" class="pl10" style="float:right">下一篇:正品保证</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font16{font-size: 16px;font-weight: bold;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/yinsibaohu.vue